import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { API } from "../apiBase";
const TOKEN_KEY = "mc_pro_token";

const ProAuthContext = createContext(null);

export function ProAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const id = axios.interceptors.request.use((cfg) => {
      const t = localStorage.getItem(TOKEN_KEY);
      // Attach pro token to /api/pro/*, /api/mssante-orders, and /api/studio/* calls
      if (t && cfg.url && (cfg.url.includes("/api/pro/") || cfg.url.includes("/api/mssante-orders") || cfg.url.includes("/api/studio/") || cfg.url.includes("/api/im/"))) {
        cfg.headers = { ...cfg.headers, Authorization: `Bearer ${t}` };
      }
      return cfg;
    });
    return () => axios.interceptors.request.eject(id);
  }, []);

  const fetchMe = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await axios.get(`${API}/pro/me`);
      setUser(data);
    } catch (e) {
      localStorage.removeItem(TOKEN_KEY);
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const setSession = useCallback((newToken, newUser) => {
    localStorage.setItem(TOKEN_KEY, newToken);
    setToken(newToken);
    setUser(newUser);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({ token, user, loading, setSession, logout, refresh: fetchMe }),
    [token, user, loading, setSession, logout, fetchMe]
  );

  return <ProAuthContext.Provider value={value}>{children}</ProAuthContext.Provider>;
}

export function useProAuth() {
  const ctx = useContext(ProAuthContext);
  if (!ctx) throw new Error("useProAuth must be used within ProAuthProvider");
  return ctx;
}
